import { PiPhone, PiMapPin } from 'react-icons/pi'
import { DescriptionText } from './DescriptionText'

interface DescriptionAndContactInfoProps {
  description?: string
  phone?: string
  address?: string
  googlePlaceUrl?: string
}

export function DescriptionAndContactInfo({
  description,
  phone,
  address,
  googlePlaceUrl,
}: DescriptionAndContactInfoProps) {
  // Don't render anything if no content
  if (!description && !phone && !address) {
    return null
  }

  return (
    <div className="flex flex-col gap-3">
      {/* Description */}
      {description && <DescriptionText text={description} />}

      {/* Contact Info */}
      {phone && (
        <div className="flex items-center gap-1">
          <PiPhone className="w-3.5 h-3.5 text-fg-secondary" />
          <a
            href={`tel:${phone}`}
            className="text-sm font-normal text-brand-bright hover:text-brand-active transition-colors tabular-nums"
          >
            {phone}
          </a>
        </div>
      )}
      {address && (
        <div className="flex items-start gap-1">
          <PiMapPin className="w-3.5 h-3.5 text-fg-secondary flex-shrink-0 mt-0.5" />
          {googlePlaceUrl ? (
            <a
              href={googlePlaceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-normal text-brand-bright hover:text-brand-active transition-colors"
            >
              {address}
            </a>
          ) : (
            <span className="text-sm font-normal text-brand-bright hover:text-brand-active transition-colors">
              {address}
            </span>
          )}
        </div>
      )}
    </div>
  )
}
